<template>
  <div>
    <Modal
      v-model="$store.state.showBase"
      width="50%"
      footer-hide
      title="图库"
      @on-visible-change="visible"
    >
      <div class="modal-menu">
        <Button
          type="primary"
          :disabled="Selection.length == 0 ? true : false"
          @click="save"
          >使用选中图片</Button
        >
        <Upload
          :action="action"
          :headers="headers"
          :show-upload-list="false"
          :format="['jpg', 'jpeg', 'png', 'gif']"
          :max-size="2048"
          :default-file-list="defaultList"
          :on-success="handleSuccess"
          :on-format-error="handleFormatError"
          :on-exceeded-size="handleMaxSize"
        >
          <Button type="primary">上传图片</Button>
        </Upload>
        <Button
          type="error"
          @click="del"
          :disabled="Selection.length == 0 ? true : false"
          >删除图片</Button
        >
      </div>
      <div class="modal-content" v-if="data.length != 0">
        <div
          class="img-item"
          v-for="item in data"
          :key="item.id"
          @click="selectOn(item)"
        >
          <img
            :src="item.url"
            alt=""
            :class="Selection.indexOf(item.newName) != -1 ? 'active' : ''"
          />
          <span class="tip" v-if="Selection.indexOf(item.url) != -1">{{
            Selection.indexOf(item.url) + 1
          }}</span>
          <Tooltip :content="item.name" max-width="200" placement="bottom">
            <p>
              {{
                item.name.length > 3
                  ? item.name.replace(
                      item.name.substring(3, item.name.indexOf(".") - 1),
                      "..."
                    )
                  : item.name
              }}
            </p>
          </Tooltip>
        </div>

        <div class="page-foot">
          <Page
            :total="Number(total)"
            :current="pageIndex"
            :page-size="pageSize"
            :simple="$store.state.isMobile"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
            show-total
            show-sizer
            show-elevator
          />
        </div>
      </div>
      <div style="width: 100%" v-else>
        <Empty :text="'暂无图片'"></Empty>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getImg, delImg } from "@/api/admin";
export default {
  data() {
    return {
      action: window.config.Base_url + "/admin/img/save",
      headers: {
        Token: sessionStorage.getItem("token"),
      },
      defaultList: [],
      pageIndex: 1,
      pageSize: 20,
      total: "",
      data: [],
      Selection: [],
    };
  },

  created() {
    this._getData();
  },
  methods: {
    // 二次清空
    visible(val) {
      this.Selection = [];
    },
    // 使用选中
    save() {
      console.log(this.Selection)
      this.$emit("use", this.Selection);
    },
    // 选中
    selectOn(row) {
      let ind = this.Selection.indexOf(row.url);
      if (ind == -1) {
        this.Selection.push(row.url);
      } else {
        this.Selection.splice(ind, 1);
      }
      console.log(this.Selection);
    },
    // 删除图片
    del() {
      this.$Modal.confirm({
        title: "删除选中图片",
        content:
          "<p>确定要删除选中图片吗？</p><p>删除选中图片后将无法恢复，请谨慎操作！</p>",
        onOk: () => {
          delImg({
            newName: this.Selection,
          }).then((res) => {
            if (res.code == 200) {
              this.$Message.success({
                background: true,
                content: res.msg,
              });
              this._getData();
            } else {
              this.$Message.error({
                background: true,
                content: res.msg,
              });
            }
            this.Selection = [];
          });
        },
      });
    },
    //  上传成功钩子
    handleSuccess(res, file, fileList) {
      if (res.code == 200) {
        this.$Message.success({
          background: true,
          content: res.msg,
        });
        this._getData();
      } else {
        this.$Message.error({
          background: true,
          content: res.msg,
        });
      }
    },

    // 文件格式验证失败时的钩子
    handleFormatError(file) {
      this.$Message.error({
        background: true,
        content: "请选择jpg、jpeg、png或gif格式图片",
      });
    },
    // 文件超出指定大小限制时的钩子
    handleMaxSize(file) {
      this.$Message.error({
        background: true,
        content: "图片大小不能超过2Mb",
      });
    },

    // 获取图片列表
    _getData() {
      getImg({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      }).then((res) => {
        this.data = res.data.data;
        this.total = res.data.total;
      });
    },
    // 分页跳转
    pageChange(val) {
      this.pageIndex = val;
      this._getData();
    },
    pageSizeChange(val) {
      this.pageSize = val;
      this._getData();
    },
  },
};
</script>

<style lang="less" scoped>
.ivu-btn {
  margin-right: 10px;
}
.ivu-upload {
  display: inline-block;
}
.modal-content {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  .img-item {
    cursor: pointer;
    width: 100px;
    height: 130px;
    margin-right: 5px;
    margin-bottom: 10px;
    position: relative;
    img {
      width: 100%;
      height: 100px;
      border-radius: 3px;
    }
    .tip {
      display: inline-block;
      width: 20px;
      height: 20px;
      line-height: 20px;
      position: absolute;
      right: 10px;
      top: 10px;
      color: #ffffff;
      background: red;
      border-radius: 50%;
      text-align: center;
    }
    .active {
      border: 2px solid red;
    }
    p {
      width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: center;
    }
  }
  .page-foot {
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }
}
</style>